export const PHONE_TYPE = 'SMS';
export const EMAIL_TYPE = 'EMAIL';
export const AUTH_APP = 'TOTP'
export const ENROLLED_STATUS = 'ENROLLED';
